import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-route-sheet',
  templateUrl: './route-sheet.component.html',
  styleUrls: ['./route-sheet.component.css']
})
export class RouteSheetComponent {
    @Input() identifier: string = "";
    @Input() childCategory: number = 0;
    @Input() parentCategory: number = 0;
    @Input() parentCoordX: string = "";
    @Input() parentCoordY: string = "";

    @Output() categoryTotal = new EventEmitter<string>();

    loadTotal(total: string) {
        this.categoryTotal.emit(total);
    }
}
